import getAPIDomain from '@signal/utils/env/apiDomain';
export var API_URL = getAPIDomain('/reports/dashboard');
export var API_PDF_URL = getAPIDomain('/reports/pdf');
export var API_VERSION = '1.0';
export var API_VERSION_ALT = 'v1';
export var UI_DESIGN_V2 = 'v2';
export var GRADIENT = true;